<template>
<div class="w-85per dp-inblock">
    <div class="title">
        <h2>신청 동의</h2>
        <p>
            - 신청 전 학습자가 반드시 확인 해야하는 규정을 입력해주세요. <br>
            - 신청 규정은 최대 5개까지 가능합니다.
        </p>
    </div>
    <div class="dp-inblock mb-10 w-100per">
        <a @click="addEditor()" class="pointer txt-green font-13 float-right"><i class="fas fa-plus mr-05 "></i>항목 추가</a>
    </div>
    <!-- 항목 추가 버튼을 누르면 .agree-box 전체가 추가 추가 추가  -->
    <div class="agree-box mb-20" v-for="(item, index) of editorDatas" :key="index">
        <input type="text" v-model="item.title" @keyup="checkTitle(item.title, index)" class="w-98per mb-20" placeholder="제목을 입력해주세요.(20자 내외)">
        <!-- 입력한 항목에 삭제 버튼 생성! -->
        <a v-if="index > 0" @click="editorDatas.splice(index, 1)" class="pointer float-right "><i class="fas fa-times"></i></a>
        <!-- <ckeditor :parentData="item.editorData" v-model="item.editorData"></ckeditor> -->
        <ckeditor-test :parentData="item.editorData" v-model="item.editorData"></ckeditor-test>
    </div>
    <!-- <div class="line"></div> -->
    <div class="mt-30 w-100per mg-auto">
        <button @click="prev()" class="admin-btn-default">이전</button>
        <button @click="next()" class="admin-btn-default float-right ml-05">다음</button>
        <button @click="save()" class="admin-btn-default float-right ml-05">저장</button>
        <button @click="preview()" class="admin-btn-default float-right">미리보기</button>
    </div>
</div>
</template>

<script>
import Ckeditor from '@/components/utils/ckEditor.vue'
import CkeditorTest from '@/components/utils/ckEditorTest.vue'
import {
    EmptyCheck
} from '@/utils/validation.js'
export default {
    data: () => ({
        editorDatas: [],
        editorData: '', // 에디터 default 내용
        editorSize: 1,
        isSaved: false, // 저장 여부
        agreeString: '캐럿글로벌은 수집한 개인정보를 다음의 목적을 위해 활용합니다.<br>'
            + 'ο 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산 콘텐츠 제공, 구매 및 요금 결제, 본인인증, 물품배송 또는 청구지 등 발송<br>'
            + 'ο 회원 관리<br>'
            + '회원제 서비스 이용에 따른 본인확인, 개인 식별, 불량회원의 부정 이용 방지와 비인가 사용 방지, 가입 의사 확인, 연령확인, 불만처리 등 민원처리, 고지사항 전달<br>'
            + 'ο 마케팅 및 광고에 활용<br>'
            + '신규 서비스(제품) 개발 및 특화, 이벤트 등 광고성 정보 전달, 인구통계학적 특성에 따른 서비스 제공 및 광고 게재, 접속 빈도 파악 또는 회원의 서비스 이용에 대한 통계<br>'
            + 'ο 기타<br>'
            + '가입횟수 제한, 분쟁조정을 위한 기록보존, 회원의 각종 합격유무 확인 및 기타 통계자료 산출<br>'
            + '<br>'
            + '캐럿글로벌은 온라인 및 모바일 회원가입, 상담, 서비스 신청 등등을 위해 아래와 같은 개인정보를 수집하고 있습니다.<br>'
            + '가. 수집하는 개인정보 항목<br>'
            + '1) 최초 회원가입 시 회원식별 및 최적화된 서비스 제공을 위해 아래와 같은 정보를 수집합니다.<br>'
            + '- 필수항목: 이름, 아이디, 비밀번호, 이메일, 휴대전화<br>'
            + '- 선택항목: 영문이름, 주소, 일반전화<br>'
            + '<br>'
            + '2) 서비스 이용과정이나 사업 처리과정에서 아래와 같은 정보들이 생성되어 수집될 수 있습니다.<br>'
            + '- 웹사이트 이용 시: 서비스 이용기록, 접속로그, 쿠키, 접속IP정보, 결제기록<br>'
            + '- 모바일 이용 시: 서비스 이용 기록, 접속 로그, 기기고유번호(디바이스 아이디 또는 IMEI)<br>'
            + '<br>'
            + '나. 수집방법<br>'
            + '1) 홈페이지를 통한 회원가입, 서비스 이용 결제, 이벤트 응모, 전화, 팩스, 고객센터 문의<br>'
            + '2) 생성정보 수집 툴을 통한 수집<br>'
            + '<br>'
            + '개인정보의 보유 및 이용기간은 다음과 같습니다.<br>'
            + '<br>'
            + 'ο 보유항목: 수집항목과 같습니다.<br>'
            + 'ο 보유근거: 이용약관 및 개인정보취급방침<br>'
            + 'ο 보유기간: 이용계약에 따른 회원자격이 유지되는 기간동안<br>'
            + '<br>'
            + '그러나 회원탈퇴 후에도 관계법령의 규정에 의하여 보존할 필요가 있는 경우 캐럿글로벌은 아래와 같이 일정 기간동안 회원정보를 보관합니다.<br>'
            + '<br>'
            + '표시/광고에 관한 기록 : 6개월 (전자상거래등에서의 소비자보호에 관한 법률)<br>'
            + '계약 또는 청약철회 등에 관한 기록 : 5년 (전자상거래등에서의 소비자보호에 관한 법률)<br>'
            + '대금결제 및 재화 등의 공급에 관한 기록 : 5년 (전자상거래등에서의 소비자보호에 관한 법률)<br>'
            + '소비자의 불만 또는 분쟁처리에 관한 기록 : 3년 (전자상거래등에서의 소비자보호에 관한 법률)<br>'
            + '신용정보의 수집/처리 및 이용 등에 관한 기록 : 3년 (신용정보의 이용 및 보호에 관한 법률) 통신비밀보호법에 따른 통신사실확인자료 3개월<br>'
    }),

    computed: {
        editorData() {
            return this.editorDatas.editorData;
        }
    },

    components: {
        Ckeditor,
        CkeditorTest
    },

    mounted() {
        if (sessionStorage.getItem('fix')) {
            var summaryIdx = sessionStorage.getItem('mainIdx')
            var params = {
                summaryIdx: summaryIdx
            }
            this.axios.get(this.axios.root + this.axios.port + `/sugang/agree/${summaryIdx}`, params)
                .then(res => {
                    if (res) {
                        console.log('res', res)
                        var agreeInfo = res.data.agreeInfo
                        // var forCount = (Object.keys(agreeInfo).length - 1) / 2

                        var forCount = 0
                        for (var item of Object.keys(agreeInfo)) {
                            if (item.includes('agree_contents')) {
                                forCount += 1
                            }
                        }

                        var editorDatas = []
                        for (var i = 1; i <= forCount; i++) {
                            console.log('시작')
                            editorDatas.push({
                                editorData: agreeInfo['agree_contents' + i.toString()],
                                title: agreeInfo['agree_title' + i.toString()],
                                view: i
                            })
                            this.editorDatas = editorDatas
                        }
                        this.editorSize = editorDatas.length

                        // 불러온 값이 없을때 디폴트 에디터 한개 만들어줘야함
                        if (editorDatas.length === 0) {
                            this.editorDatas.push({
                                editorData: '',
                                title: ''
                            })
                        }
                    }
                }).catch(err => {
                    console.log(err)
                    alert(err)
                })
        } else {
            this.editorDatas.push({
                editorData: this.agreeString,
                title: '개인정보 수집 및 이용에 동의합니다.'
            })
        }
    },

    methods: {
        // 타이틀 20자 초과일때 alert
        checkTitle(title, index) {
            if (title.length > 20) {
                this.editorDatas[index]
                this.editorDatas[index].title = title.substring(0, 20)
                console.log('this.editorDatas[index].title', this.editorDatas[index].title)
                alert('페이지 제목은 20자 이내로 입력해주세요.')
                return false
            }
        },

        async renders(forCount, editorDatas, agreeInfo) {
            this.renderFunc(forCount, editorDatas, agreeInfo)
        },

        async tempEditData(forCount, editorDatas) {
            for (var i = 1; i <= forCount; i++) {
                editorDatas.push({
                    editorData: '123',
                    title: '123'
                })
            }
        },

        async renderFunc(forCount, editorDatas, agreeInfo) {
            for (var i = 1; i <= forCount; i++) {
                console.log('시작')
                editorDatas.push({
                    editorData: agreeInfo['agree_contents' + i.toString()],
                    title: agreeInfo['agree_title' + i.toString()],
                    view: i
                })
                this.editorDatas = editorDatas
            }
        },

        // 미리보기
        preview() {
            if (!this.isSaved) {
                alert('미리보기를 하려면 먼저 저장을 해야합니다.')
                return false
            }
            let routeData = this.$router.resolve({
                name: 'preview-agree',
                query: {
                    mainIdx: sessionStorage.getItem('mainIdx')
                }
            });
            window.open(routeData.href, '_blank');
        },

        // 이전 페이지 이동
        prev() {
            var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
            var idx = pOrder.indexOf('agree') - 1
            this.$router.push(`/admin/reg/${pOrder[idx]}`)
            // this.$router.push('/admin/reg/input')
        },

        // 다음 페이지 이동
        async next() {
            if (!this.checkEmptyData()) {
                return false
            } else {
                if (this.isSaved) {
                    var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
                    var idx = pOrder.indexOf('agree') + 1
                    sessionStorage.setItem('step', pOrder[idx])
                    this.$router.push(`/admin/reg/${pOrder[idx]}`)
                } else {
                    alert('저장을 먼저 해주세요.')
                }
            }
        },

        // 현재 페이지 임시 저장
        async save() {
            if (!this.checkEmptyData()) {
                return false
            }

            var params = {}

            for (var [index, item] of this.editorDatas.entries()) {
                params['agreeTitle' + (index + 1)] = item.title
                params['agreeContents' + (index + 1)] = item.editorData
            }

            params['mainIdx'] = sessionStorage.getItem('mainIdx')

            await this.axios.put(this.axios.root + this.axios.port + '/sugang/agree', params)
                .then(res => {
                    console.log('res', res)
                    if (res.data.err === 0) {
                        this.isSaved = true
                        alert('저장되었습니다.')
                    }
                })
        },

        // 각 에디터 타이틀에 빈값 있는지 확인
        checkEmptyData() {
            for (var [index, item] of this.editorDatas.entries()) {
                if (!EmptyCheck(item.title, (index + 1) + '번째 신청 동의 제목')) {
                    return false
                }
                if (!EmptyCheck(item.editorData, (index + 1) + '번째 신청 동의 내용')) {
                    return false
                }
            }
            return true
        },

        // 에디터 추가
        addEditor() {
            if (this.editorDatas.length < 5) {
                this.editorDatas.push({
                    editorData: '',
                    title: ''
                })
            } else {
                alert('최대 5개까지만 추가 가능합니다.')
            }
        }
    }
}
</script>
